import enviro from 'enviro';
export const getIsProdAcceptanceTest = () => enviro.isProd() && document.cookie.includes('hs_selenium');